<div class="local-import">
  <div class="drag-drop" [ngClass]="{'active': isDropAreaActive, 'disabled': isDragAndDropDisabled}"
    (drop)="onDropFiles($event)" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)">
    <div class="drag-drop-overflow"></div>
    <div class="drag-drop-content">
      <div class="drag-drop-text">
        <label>{{ 'localImport.dragAndDrop.title' | translate }}</label>
        <p class="drag-drop-text-hint" [class.disabled]="isDragAndDropDisabled">
          {{ 'localImport.dragAndDrop.description' | translate }}
        </p>
      </div>
      <div class="drag-drop-actions">
        <fw-button variant="outline" size="small" leftIcon="folder-add" [disabled]="isDragAndDropDisabled"
          (click)="folderInput.click(); folderInput.value = ''">
          <div class="drag-drop-action-container">
            {{ 'localImport.dragAndDrop.buttons.browseFolders' | translate }}
          </div>
        </fw-button>
        <fw-button variant="outline" size="small" leftIcon="document-file-add-plus-bottom-left"
          [disabled]="isDragAndDropDisabled" (click)="filesInput.click(); folderInput.value = ''">
          <div class="drag-drop-action-container">
            {{ 'localImport.dragAndDrop.buttons.browseFiles' | translate }}
          </div>
        </fw-button>
      </div>
      <input [disabled]="isDragAndDropDisabled" hidden type="file" #folderInput webkitdirectory
        (change)="onSelectFiles($event)">
      <input [disabled]="isDragAndDropDisabled" hidden type="file" #filesInput multiple
        (change)="onSelectFiles($event)">
    </div>
  </div>
  <div *ngIf="filesInfo.length > 0">
    <local-import-progress-card [completedFiles]="completedFiles" [failedFiles]=failedFiles [filesInfo]="filesInfo"
      [progressBarValue]="progressBarValue"
      [remainingTimeMessage]="remainingTimeMessage | formatTime"></local-import-progress-card>
    <local-import-table class="import-table" [filesInfo]="filesInfo" (cancelFiles)="handleCancel($event)"
      (retryFiles)="handleRetry($event)"></local-import-table>
  </div>
</div>
